
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/lyziarske-strediska",
      function () {
        return require("private-next-pages/[region]/lyziarske-strediska.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/lyziarske-strediska"])
      });
    }
  